import {useComponentPeopleList} from "./component-people-list/component-people-list";
import {useComponentCategories} from "./component-categories/component-categories";
import {useComponentSubscribe} from "./component-subscribe/component-subscribe";

export function useComponents() {
    useComponentCategories();
    useComponentSubscribe();
    useComponentPeopleList();
}
